import { defineMessages } from 'react-intl';

export default defineMessages({
  noResultsFound: {
    id: 'neptune.SelectInput.noResultsFound',
    defaultMessage: 'No results found',
    description: 'When a user-initiated search produces no results.',
  },
});
